import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container } from '@design-system/container';
import { useMatchBreakpoint } from '@design-system/theme';
import { styled } from 'styled-components';
import { Picture } from './Picture';
import { Title } from './Title';
export const PictureOnly = ({ coverPictureUrl, title }) => {
    const isBreakpointMobile = useMatchBreakpoint('s');
    return (_jsxs(StyledContainer, { dataTestId: "appheader-container", children: [_jsx(Title, { customPadding: {
                    pb: 4,
                    pt: isBreakpointMobile ? 6 : 0,
                    px: isBreakpointMobile ? 4 : 0,
                }, title: title }), _jsx(Picture, { coverPictureUrl: coverPictureUrl })] }));
};
const StyledContainer = styled(Container).attrs(() => ({
    flexDirection: 'column',
    justifyContent: 'start',
    px: {
        l: 8,
        m: 6,
    },
    py: {
        l: 6,
        m: 4,
    },
})) ``;
//# sourceMappingURL=PictureOnly.js.map